import React from "react";
import { Typography, Box } from "@mui/material";
import { LegalPage } from "../components/LegalPage.tsx";

export const TermsPage: React.FC = () => {
  // Terms and conditions content with proper formatting
  const termsContent = (
    <>
      <Typography variant="h5" component="h2" gutterBottom>
        Algemene Voorwaarden Pippaya Hondenopvang
      </Typography>
      
      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 4 }}>
        Artikel 1 – Definities
      </Typography>
      <Typography paragraph>
        In deze algemene voorwaarden wordt verstaan onder:
      </Typography>
      <Typography component="ol" sx={{ pl: 2 }}>
        <li>Hondenopvang: Pippaya Hondenopvang, gevestigd te Giessenburg, Boezem 7, ingeschreven bij de Kamer van Koophandel onder nummer 96754974.</li>
        <li>Eigenaar: De natuurlijke of rechtspersoon die een hond ter opvang aanbiedt.</li>
        <li>Hond: De hond die door de eigenaar aan de opvang wordt toevertrouwd.</li>
        <li>Overeenkomst: De overeenkomst tussen de hondenopvang en de eigenaar voor het opvangen van de hond.</li>
      </Typography>
      
      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 4 }}>
        Artikel 2 – Toepasselijkheid
      </Typography>
      <Typography component="ol" sx={{ pl: 2 }}>
        <li>Deze algemene voorwaarden zijn van toepassing op alle diensten die de hondenopvang aanbiedt.</li>
        <li>Door het reserveren van opvang stemt de eigenaar in met deze algemene voorwaarden.</li>
      </Typography>
      
      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 4 }}>
        Artikel 3 – Reservering en Betaling
      </Typography>
      <Typography component="ol" sx={{ pl: 2 }}>
        <li>Reserveringen zijn pas definitief nadat de eigenaar een aanbetaling van 30% van de totale opvangkosten heeft voldaan. Deze dienen 2 weken na overeenstemming te zijn voldaan.</li>
        <li>Het resterende bedrag dient uiterlijk twee weken voor de start van de opvang volledig betaald te zijn.</li>
        <li>Bij annulering gelden de volgende kosten:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px', marginTop: '8px' }}>
            <li>7 weken of langer voor aanvang: De eigenaar verliest de aanbetaling van 30%.</li>
            <li>Tussen 4 en 6 weken voor aanvang: De eigenaar is 50% van het totale opvangbedrag verschuldigd.</li>
            <li>3 weken of korter voor aanvang: De eigenaar is het volledige opvangbedrag verschuldigd.</li>
          </ul>
        </li>
        <li>Indien de betaling niet tijdig wordt voldaan, behoudt de hondenopvang zich het recht voor de reservering te annuleren, waarbij de aanbetaling niet wordt terugbetaald.</li>
      </Typography>
      
      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 4 }}>
        Artikel 4 – Intake en Kennismaking
      </Typography>
      <Typography component="ol" sx={{ pl: 2 }}>
        <li>Voordat een hond voor het eerst wordt opgevangen, vindt er een verplichte intake en kennismaking plaats. Dit gesprek is gratis en bedoeld om de hond en eigenaar beter te leren kennen.</li>
        <li>Tijdens de intake beoordeelt de hondenopvang of de hond geschikt is voor de opvangomgeving. Factoren zoals gedrag, socialisatie en gezondheid worden meegenomen in de beoordeling.</li>
        <li>Indien een hond speciale zorg nodig heeft, zoals medicatie, speciaal dieet of extra begeleiding, kan er een toeslag worden berekend. Dit wordt vooraf met de eigenaar besproken.</li>
        <li>De hondenopvang behoudt zich het recht voor om een hond te weigeren indien deze agressief, angstig of ongeschikt blijkt voor groepsopvang.</li>
      </Typography>
      
      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 4 }}>
        Artikel 5 – Gezondheid en Vaccinaties
      </Typography>
      <Typography component="ol" sx={{ pl: 2 }}>
        <li>De eigenaar dient ervoor te zorgen dat de hond up-to-date is met de benodigde vaccinaties, waaronder hondenziekte, parvo, kennelhoest en rabies (indien van toepassing). Bij inenting met een nieuwe vaccinatie dient de eigenaar de hondenopvang hiervan op de hoogte te stellen.</li>
        <li>Zonder geldige vaccinaties kan de hond niet worden opgevangen. De hondenopvang behoudt zich het recht voor om een hond te weigeren als deze niet voldoet aan de vereisten voor gezondheid en vaccinaties.</li>
      </Typography>
      
      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 4 }}>
        Artikel 6 – Verzorging en Aansprakelijkheid
      </Typography>
      <Typography component="ol" sx={{ pl: 2 }}>
        <li>De hondenopvang zal de hond met de grootst mogelijke zorg behandelen, maar kan niet aansprakelijk worden gesteld voor ziekte, letsel of overlijden van de hond.</li>
        <li>Tijdens het verblijf bij de hondenopvang is de eigenaar verantwoordelijk voor het meegeven van het eigen voer van de hond. Mocht blijken dat dit niet voldoende is gedurende de periode van de opvang zal er voer gekocht worden. De kosten hiervoor zullen doorberekend worden aan de eigenaar.</li>
        <li>Indien de hond tijdens de opvang medische zorg nodig heeft, zal de hondenopvang een dierenarts raadplegen. De kosten hiervan zijn voor rekening van de eigenaar.</li>
        <li>De eigenaar blijft aansprakelijk voor schade die de hond veroorzaakt aan derden, andere honden of eigendommen van de opvang.</li>
        <li>De hondenopvang is niet aansprakelijk voor schade of verlies van eigendommen van de eigenaar.</li>
      </Typography>
      
      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 4 }}>
        Artikel 7 – Ophaal- en Brengtijden
      </Typography>
      <Typography component="ol" sx={{ pl: 2 }}>
        <li>De hond dient op de afgesproken tijd gebracht en opgehaald te worden.</li>
        <li>Indien een hond later dan de afgesproken tijd wordt opgehaald zonder voorafgaand overleg, worden extra kosten van €7,50 per uur in rekening gebracht.</li>
        <li>Indien de hond niet op de afgesproken dag wordt opgehaald en er geen contact mogelijk is met de eigenaar, behoudt de hondenopvang zich het recht voor verdere maatregelen te nemen. Eventuele extra opvangdagen worden in rekening gebracht.</li>
      </Typography>
      
      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 4 }}>
        Artikel 8 – Annulering en Overmacht
      </Typography>
      <Typography component="ol" sx={{ pl: 2 }}>
        <li>Bij annulering door de eigenaar gelden de annuleringsvoorwaarden zoals genoemd in artikel 3.</li>
        <li>De hondenopvang kan de opvang annuleren bij overmacht, zoals extreme weersomstandigheden, ziekte van het personeel of andere onvoorziene omstandigheden. In dat geval wordt de eigenaar zo snel mogelijk geïnformeerd en krijgt de eigenaar de volledige betaling terug, tenzij er een andere oplossing wordt overeengekomen.</li>
      </Typography>
      
      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 4 }}>
        Artikel 9 – Noodgevallen en Communicatie
      </Typography>
      <Typography component="ol" sx={{ pl: 2 }}>
        <li>In geval van een medisch noodgeval wordt de eigenaar zo snel mogelijk op de hoogte gesteld.</li>
        <li>Indien de eigenaar niet bereikbaar is, wordt de hond naar de dierenarts gebracht voor behandeling. De kosten hiervan zijn voor rekening van de eigenaar.</li>
      </Typography>
      
      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 4 }}>
        Artikel 10 – Gedragsproblemen
      </Typography>
      <Typography component="ol" sx={{ pl: 2 }}>
        <li>Indien tijdens de opvang gedragsproblemen optreden, zoals agressie of overmatig blaffen, zal de hondenopvang proberen dit op te lossen.</li>
        <li>Als het gedrag niet te corrigeren is, kan de opvang de hond weigeren of de eigenaar vroegtijdig verzoeken de hond op te halen.</li>
      </Typography>
      
      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 4 }}>
        Artikel 11 – Dierenverzekeringen
      </Typography>
      <Typography component="ol" sx={{ pl: 2 }}>
        <li>De eigenaar wordt geadviseerd om een dierenverzekering af te sluiten voor de hond, die medische kosten dekt in geval van ziekte of letsel tijdens de opvang.</li>
      </Typography>
      
      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 4 }}>
        Artikel 12 – Privacy en Gegevensverwerking
      </Typography>
      <Typography component="ol" sx={{ pl: 2 }}>
        <li>Persoonsgegevens van de eigenaar worden alleen gebruikt voor de uitvoering van de overeenkomst en niet gedeeld met derden zonder toestemming.</li>
        <li>De hondenopvang mag foto's van de hond maken en gebruiken voor promotionele doeleinden, inclusief op sociale media en de website van de hondenopvang, tenzij de eigenaar hier schriftelijk bezwaar tegen maakt.</li>
      </Typography>
      
      <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 4 }}>
        Artikel 13 – Slotbepalingen
      </Typography>
      <Typography component="ol" sx={{ pl: 2 }}>
        <li>Op deze overeenkomst is Nederlands recht van toepassing.</li>
        <li>Geschillen worden bij voorkeur in onderling overleg opgelost. Indien dit niet mogelijk is, worden geschillen voorgelegd aan de bevoegde rechter in de vestigingsplaats van de hondenopvang.</li>
      </Typography>
    </>
  );

  return (
    <LegalPage
      title="Algemene Voorwaarden"
      content={termsContent}
    />
  );
}; 